import React from 'react';
import { Code2, Server, TestTube } from 'lucide-react';
import { about } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-20 bg-slate-900">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center">
          About Me
        </h2>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <p className="text-lg text-slate-300 leading-relaxed mb-8">
              {about.summary}
            </p>
            
            {/* Highlights */}
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-teal-500/10 rounded-lg">
                  <TestTube className="w-6 h-6 text-teal-400" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Test Automation Expert</h3>
                  <p className="text-slate-400">Specializing in building scalable, maintainable automation frameworks with self-healing capabilities</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="p-3 bg-teal-500/10 rounded-lg">
                  <Server className="w-6 h-6 text-teal-400" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Backend Development</h3>
                  <p className="text-slate-400">Creating robust backend systems and REST APIs using Spring Boot with clean architecture</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="p-3 bg-teal-500/10 rounded-lg">
                  <Code2 className="w-6 h-6 text-teal-400" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Problem Solver</h3>
                  <p className="text-slate-400">Focused on solving real-world challenges in software quality, reliability, and performance</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Visual Element */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-8 border border-slate-700">
              <div className="absolute -inset-1 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-2xl opacity-20 blur-xl"></div>
              <div className="relative space-y-6">
                <div className="flex items-center justify-between">
                  <span className="text-slate-400">Experience</span>
                  <span className="text-teal-400 font-semibold">1+ Years</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-slate-400">Projects Completed</span>
                  <span className="text-teal-400 font-semibold">10+</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-slate-400">Frameworks Built</span>
                  <span className="text-teal-400 font-semibold">3+</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-slate-400">Test Cases Automated</span>
                  <span className="text-teal-400 font-semibold">500+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
